import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0351d21e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "prophet-box render-hide-scroll"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "prophet-card-img"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "prophet-card-tit"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", {
  class: "tit"
}, "预测金额，赢取奖品", -1));
const _hoisted_9 = {
  class: "des"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/mdwxapp/prophet/prophet_list_gif_icon.png"
}, null, -1));
const _hoisted_11 = {
  class: "prize_title"
};
const _hoisted_12 = {
  class: "des"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/mdwxapp/prophet/prophet_list_time_icon.png"
}, null, -1));
const _hoisted_14 = {
  class: "status"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/mdwxapp/prophet/prophet_list_support_icon.png"
}, null, -1));
const _hoisted_16 = {
  class: "prize_title"
};
const _hoisted_17 = {
  key: 1,
  class: "des"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/mdwxapp/prophet/prophet_list_gif_icon.png"
}, null, -1));
const _hoisted_19 = {
  class: "prize_title"
};
const _hoisted_20 = {
  class: "prophet-card-btn-box"
};
const _hoisted_21 = {
  key: 0,
  class: "prophet-card-btn-active"
};
const _hoisted_22 = {
  key: 1,
  class: "prophet-card-btn"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "去预言", -1));
const _hoisted_25 = {
  key: 0,
  class: "prophet-card-index"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  return $data.list && $data.list.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['prophet-card', {
        'prophet-card-more': $data.list.length > 1
      }]),
      onClick: $event => $options.predictionAction(item)
    }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      class: "card-img",
      src: _ctx.$imgUrlFilter(item.prize_pic, 108, 108)
    }, null, 8, _hoisted_5), _createElementVNode("img", {
      class: "prize",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prediction-prizze-icon.png', 60)
    }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, (item.status == 1 || item.status == 2 || item.status == 3) && item.success_bet_num > 0 ? (_openBlock(), _createBlock(_component_van_swipe, {
      key: 0,
      class: "prophet-card-swipe",
      autoplay: 2500,
      "show-indicators": false,
      vertical: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_swipe_item, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", _hoisted_11, _toDisplayString(item.prize_title), 1)])]),
        _: 2
      }, 1024), _createVNode(_component_van_swipe_item, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString($data.statusMap[item.status]), 1), _hoisted_15, _createElementVNode("span", _hoisted_16, _toDisplayString($options.numFitWanFormat(item.success_bet_num)) + "人次预言", 1)])]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024)) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, _toDisplayString(item.prize_title), 1)]))]), _createElementVNode("div", _hoisted_20, [$props.activity_id && $props.activity_id == item.activity_id ? (_openBlock(), _createElementBlock("div", _hoisted_21, "当前预言")) : (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("img", {
      class: "icon",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prediction-star-icon.png', 28)
    }, null, 8, _hoisted_23), _hoisted_24]))]), $data.list.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($data.list.length - index) + " / " + _toDisplayString($data.list.length), 1)) : _createCommentVNode("", true)], 10, _hoisted_3);
  }), 128))])])) : _createCommentVNode("", true);
}